import React from 'react';
import PropTypes from 'prop-types';
import './controlBar.styles.css';
import VolumeBar from './VolumeBar';
import DurationLabel from './durationLabel';
import FullScreenButton from './fullScreenButton';
import ControlsVideoProgressbar from './controls.video.progressbar';
import PlaylistButton from './PlaylistButton';

export default function ControlBar({ config, videoPlayer, playlistmodel }) {
  return (
    <div className="tpx-control-bar">
      <div className="tpx-controls-up">
        <VolumeBar config={config} videoPlayer={videoPlayer} />
        <DurationLabel videoPlayer={videoPlayer} />
        <div className="tppx-controls-buttons">
          <PlaylistButton config={config} videoPlayer={videoPlayer} playlistmodel={playlistmodel} />
          <FullScreenButton videoPlayer={videoPlayer} />
        </div>
      </div>
      <div className="tpx-controls-down">
        <ControlsVideoProgressbar config={config} videoPlayer={videoPlayer} />
      </div>
    </div>
  );
}

ControlBar.propTypes = {
  config: PropTypes.object.isRequired,
  videoPlayer: PropTypes.object.isRequired,
  playlistmodel: PropTypes.object.isRequired,
};
